import { createAction, props } from '@ngrx/store';

export const gridReady = createAction(
    '[Create Request - TWE Table] AG Grid Ready',
    props<{ gridReady: boolean }>()
)